import { NewEnumTranslator as EnumTranslator } from '@skylab-shared/dataModel';

export enum ProductKindInReport {
    Merchandize = 'Merchandize',
    Service = 'Service',
    OneOff = 'OneOff'
}

EnumTranslator.registerEnum(ProductKindInReport, 'ProductKindInReport');
